/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface VoucherType { 
    id?: number;
    name?: VoucherType.NameEnum;
    unit_of_measure?: string;
    description?: string;
}
export namespace VoucherType {
    export type NameEnum = 'TIME_VOUCHER' | 'PRICINGPLAN_VOUCHER' | 'WALLETBONUS_VOUCHER';
    export const NameEnum = {
        TIMEVOUCHER: 'TIME_VOUCHER' as NameEnum,
        PRICINGPLANVOUCHER: 'PRICINGPLAN_VOUCHER' as NameEnum,
        WALLETBONUSVOUCHER: 'WALLETBONUS_VOUCHER' as NameEnum
    };
}